"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[340],{

/***/ 5267:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* reexport */ courier_services_NavbarCourierServices; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 12 modules
var es = __webpack_require__(1894);
// EXTERNAL MODULE: ./node_modules/next/future/image.js
var future_image = __webpack_require__(1608);
var image_default = /*#__PURE__*/__webpack_require__.n(future_image);
;// CONCATENATED MODULE: ./parts/courier-services/NavbarCourierServices/index.js
/* eslint-disable no-unused-vars */ /* eslint-disable no-prototype-builtins */ /* eslint-disable @next/next/no-img-element */ 




function NavbarCourierServices(param) {
    var topFunction = param.topFunction, data = param.data, changeLanguage = param.changeLanguage, language = param.language;
    // buat misahin posisi menu navbar
    var idFreeConsultation = 20;
    // buat conditional routing per id detail
    var idCourier = 2;
    var idInternational = 7;
    // buat redirect ke luar web
    var idEmail = 22;
    var handleClickFreeConsul = function(url) {
        window.open(url, "_blank", "noopener,noreferrer");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/",
                locale: language === "ID" ? "id" : "en",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: data === null || data === void 0 ? void 0 : data.logo,
                        alt: data === null || data === void 0 ? void 0 : data.alt_logo,
                        // layout="fill"
                        width: 125,
                        height: 62
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "top-nav-menu",
                children: (data === null || data === void 0 ? void 0 : data.HeaderMenus) !== undefined && (data === null || data === void 0 ? void 0 : data.HeaderMenus.map(function(item, index) {
                    return item.id !== idFreeConsultation && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: item.hasOwnProperty("child") ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "link-sub-nav",
                                        children: language === "ID" ? item.id_menu_name : item.en_menu_name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        className: "sub-nav-content",
                                        children: item.child.map(function(child, childIndex) {
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    children: [
                                                        child.hasOwnProperty("id_url") || child.hasOwnProperty("en_url") ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: language === "ID" ? "/" + (child === null || child === void 0 ? void 0 : child.id_url) : "/" + (child === null || child === void 0 ? void 0 : child.en_url),
                                                            locale: language === "ID" ? "id" : "en",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                children: language === "ID" ? child.id_menu_name : child.en_menu_name
                                                            })
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: language === "ID" ? child.id_menu_name : child.en_menu_name
                                                        }),
                                                        child.hasOwnProperty("child") ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                                className: "subs-nav",
                                                                children: child.child.map(function(childofchild, childofchildIndex) {
                                                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                href: (child === null || child === void 0 ? void 0 : child.id) === idCourier ? "/courier-services/".concat(language === "EN" ? childofchild === null || childofchild === void 0 ? void 0 : childofchild.en_url : childofchild === null || childofchild === void 0 ? void 0 : childofchild.id_url) : child.id === idInternational ? "/international-delivery/".concat(language === "EN" ? childofchild === null || childofchild === void 0 ? void 0 : childofchild.en_url : childofchild === null || childofchild === void 0 ? void 0 : childofchild.id_url) : "/supply-chain/".concat(language === "EN" ? childofchild === null || childofchild === void 0 ? void 0 : childofchild.en_url : childofchild === null || childofchild === void 0 ? void 0 : childofchild.id_url),
                                                                                locale: language === "ID" ? "id" : "en",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                    children: language === "ID" ? childofchild.id_menu_name : childofchild.en_menu_name
                                                                                })
                                                                            })
                                                                        }, childofchildIndex)
                                                                    });
                                                                })
                                                            })
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                                    ]
                                                }, childIndex)
                                            });
                                        })
                                    })
                                ]
                            }, index)
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: language === "ID" ? "/" + (item === null || item === void 0 ? void 0 : item.id_url) : "/" + (item === null || item === void 0 ? void 0 : item.en_url),
                                    locale: language === "ID" ? "id" : "en",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        children: language === "ID" ? item.id_menu_name : item.en_menu_name
                                    })
                                })
                            })
                        })
                    });
                }))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "right",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "top-nav-menu top-consultation",
                        children: (data === null || data === void 0 ? void 0 : data.HeaderMenus) !== undefined && (data === null || data === void 0 ? void 0 : data.HeaderMenus.map(function(item, index) {
                            return item.id === idFreeConsultation && /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "link-sub-nav",
                                        children: language === "EN" ? item.en_menu_name : item.id_menu_name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        className: "sub-nav-content",
                                        children: item.child.map(function(child, childIndex) {
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: (child === null || child === void 0 ? void 0 : child.id) === idEmail ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: language === "ID" ? "/" + (child === null || child === void 0 ? void 0 : child.id_url) : "/" + (child === null || child === void 0 ? void 0 : child.en_url),
                                                        locale: language === "ID" ? "id" : "en",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            children: language === "ID" ? child.id_menu_name : child.en_menu_name
                                                        })
                                                    })
                                                }, childIndex) : /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    style: {
                                                        cursor: "pointer"
                                                    },
                                                    onClick: function() {
                                                        return handleClickFreeConsul(language === "EN" ? child.en_url : child.id_url);
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "link-sub-nav",
                                                        children: language === "ID" ? child.id_menu_name : child.en_menu_name
                                                    })
                                                }, childIndex)
                                            });
                                        })
                                    })
                                ]
                            }, index);
                        }))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "top-nav-menu",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: "".concat("https://cklcargo.com/", "/assets/icons/globe.png"),
                                            width: 39,
                                            height: 30,
                                            alt: "ckl-logo"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-language",
                                            children: language
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    className: "sub-nav-content",
                                    children: [
                                        language === "ID" && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            onClick: changeLanguage,
                                            style: {
                                                cursor: "pointer"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "EN"
                                            })
                                        }),
                                        language === "EN" && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            onClick: changeLanguage,
                                            style: {
                                                cursor: "pointer"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "ID"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "home",
                        style: {
                            cursor: "pointer"
                        },
                        onClick: topFunction,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "".concat("https://cklcargo.com/", "/assets/icons/home.png"),
                            width: 39,
                            height: 30,
                            alt: "home"
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var courier_services_NavbarCourierServices = (NavbarCourierServices);

;// CONCATENATED MODULE: ./parts/courier-services/index.js




/***/ }),

/***/ 1671:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "F": function() { return /* reexport */ frontendAPI; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(655);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
;// CONCATENATED MODULE: ./utils/axios.js
/* eslint-disable no-undef */ /* eslint-disable no-prototype-builtins */ 
// import { store } from "src/store";
var API = axios_default().create({
    baseURL: "https://api.cklcargo.com/",
    headers: {
        "Content-Type": "application/json"
    }
});
API.interceptors.request.use(function(config) {
    // const token = store.getState().user.token;
    // if (token) {
    //   config.headers["x-access-token"] = `${token}`;
    // }
    return config;
}, function(error) {
    return Promise.reject(error);
});
API.interceptors.response.use(function(response) {
    if (response.status === 200 && (response === null || response === void 0 ? void 0 : response.data.hasOwnProperty("new_token"))) {
    // store.dispatch(() => ({ token: response?.data?.new_token }));
    // console.log("SET TOKEN ", response.data.new_token);
    }
    return response;
}, function(error) {
    return Promise.reject(error);
});
/* harmony default export */ var utils_axios = (API);

;// CONCATENATED MODULE: ./services/frontendAPI.js
/* eslint-disable */ 


var FrontendAPI = {
    landingPage: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var data;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        utils_axios.get("frontEnd/landingPage")
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    }),
    getPageBySlug: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var slug, data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        slug = param.slug;
                        return [
                            4,
                            utils_axios.get("frontEnd/page/".concat(slug))
                        ];
                    case 1:
                        data = _state.sent().data;
                        return [
                            2,
                            data
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(),
    headerFooter: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var data;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        utils_axios.get("frontEnd/headerFooter")
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    }),
    career: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var data;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        utils_axios.get("frontEnd/career")
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    }),
    officePinPoint: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var data;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        utils_axios.get("frontEnd/officePinPoint")
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    }),
    clientNPartner: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(type) {
            var data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            utils_axios.get("frontEnd/clientNPartner/".concat(type))
                        ];
                    case 1:
                        data = _state.sent().data;
                        return [
                            2,
                            data
                        ];
                }
            });
        });
        return function(type) {
            return _ref.apply(this, arguments);
        };
    }(),
    company: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var data;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        utils_axios.get("frontEnd/company")
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    }),
    FAQ: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var data;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        utils_axios.get("frontEnd/FAQ")
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    }),
    post: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var sortField, sortType, currentPage, pageSize, data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        sortField = param.sortField, sortType = param.sortType, currentPage = param.currentPage, pageSize = param.pageSize;
                        return [
                            4,
                            utils_axios.get("/frontEnd/post?sort=".concat(sortField, "&sortType=").concat(sortType, "&pageSize=").concat(pageSize, "&currentPage=").concat(currentPage))
                        ];
                    case 1:
                        data = _state.sent().data;
                        return [
                            2,
                            data
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(),
    getPostBySlug: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var slug, data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        slug = param.slug;
                        return [
                            4,
                            utils_axios.get("frontEnd/post/".concat(slug))
                        ];
                    case 1:
                        data = _state.sent().data;
                        return [
                            2,
                            data
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(),
    contactEmail: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(params) {
            var data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            utils_axios.post("frontEnd/contactEmail", params)
                        ];
                    case 1:
                        data = _state.sent().data;
                        return [
                            2,
                            data
                        ];
                }
            });
        });
        return function(params) {
            return _ref.apply(this, arguments);
        };
    }(),
    getContactEmail: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var data;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        utils_axios.get("frontEnd/contactEmail")
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    }),
    sendJobApplication: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(params) {
            var data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            utils_axios.post("frontEnd/sendJobApplication", params)
                        ];
                    case 1:
                        data = _state.sent().data;
                        return [
                            2,
                            data
                        ];
                }
            });
        });
        return function(params) {
            return _ref.apply(this, arguments);
        };
    }(),
    WCU: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var data;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        utils_axios.get("frontEnd/why-choose-us")
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    }),
    sex: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var data;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        utils_axios.get("frontEnd/sex")
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    }),
    maritalStatus: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var data;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        utils_axios.get("frontEnd/maritalStatus")
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    }),
    educationDegree: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var data;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        utils_axios.get("frontEnd/educationDegree")
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    }),
    lastJobDuration: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var data;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        utils_axios.get("frontEnd/lastJobDuration")
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    }),
    careerDivision: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var data;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        utils_axios.get("frontEnd/careerDivision")
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    }),
    careerDivisionById: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var id, search, data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        id = param.id, search = param.search;
                        return [
                            4,
                            utils_axios.get("frontEnd/careerDivision/".concat(id, "?search=").concat(search))
                        ];
                    case 1:
                        data = _state.sent().data;
                        return [
                            2,
                            data
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(),
    careerById: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            utils_axios.get("frontEnd/career/".concat(id))
                        ];
                    case 1:
                        data = _state.sent().data;
                        return [
                            2,
                            data
                        ];
                }
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var frontendAPI = (FrontendAPI);

;// CONCATENATED MODULE: ./services/index.js




/***/ })

}]);